export default __webpack_public_path__ + "static/media/logo.05a9b98a.png";